import { DataOoc } from './data-ooc.js'
import { DataOocMutation } from './data-ooc-mutation.js'
import { DataOocQuery } from './data-ooc-query.js'
import { DataOocSubscription } from './data-ooc-subscription.js'

export const entities = [DataOoc]
export const resolvers = [DataOocQuery, DataOocMutation, DataOocSubscription]
